// Minimal SVG line chart for body trends. Calm, no axes — just the shape.
import type { BodyPoint } from "@hh/shared";

export function Sparkline({
  points,
  color,
  height = 64,
}: {
  points: BodyPoint[];
  color: string;
  height?: number;
}) {
  if (points.length < 2) {
    return <div class="spark-empty">Not enough data yet</div>;
  }
  const W = 300;
  const H = height;
  const pad = 6;
  const vals = points.map((p) => p.value);
  const min = Math.min(...vals);
  const max = Math.max(...vals);
  const range = max - min || 1;
  const xStep = (W - pad * 2) / (points.length - 1);
  const coords = points.map((p, i) => {
    const x = pad + i * xStep;
    const y = pad + (H - pad * 2) * (1 - (p.value - min) / range);
    return [x, y] as const;
  });
  const path = coords.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const area = `${path} L${coords[coords.length - 1][0].toFixed(1)},${H - pad} L${pad},${H - pad} Z`;
  const [lx, ly] = coords[coords.length - 1];

  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" style={{ display: "block" }}>
      <path d={area} fill={color} opacity="0.12" />
      <path d={path} fill="none" stroke={color} stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
      <circle cx={lx} cy={ly} r="3.5" fill={color} />
    </svg>
  );
}
